var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.33366 9.50789C2.75633 9.50789 0.666992 7.41856 0.666992 4.84123C0.666992 2.2639 2.75633 0.174561 5.33366 0.174561C7.91099 0.174561 10.0003 2.2639 10.0003 4.84123C10.0003 5.91964 9.63453 6.91262 9.02024 7.70285L12.1628 10.8454L11.3378 11.6704L8.19528 8.52781C7.40505 9.1421 6.41207 9.50789 5.33366 9.50789ZM8.83366 4.84123C8.83366 6.77422 7.26666 8.34123 5.33366 8.34123C3.40066 8.34123 1.83366 6.77422 1.83366 4.84123C1.83366 2.90823 3.40066 1.34123 5.33366 1.34123C7.26666 1.34123 8.83366 2.90823 8.83366 4.84123Z",
    fill: "white",
    fillOpacity: 0.75
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.9f0a5fd5d9a2aaa2522cec86d3f6d8ec.svg";
export { ForwardRef as ReactComponent };